import { Grid, Tooltip, Typography } from "@mui/material";
import { Paper } from "../../../components";
import { categories } from "./audienceObjects";
import { colors } from "../../css components/Style";
import { Fragment } from "react";

export default function ContributorCategories() {
  return (
    <Fragment>
      <Grid style={{ margin: "20px 0" }} textAlign={"center"}>
        <Typography
          style={{
            background: colors.publicisBlue,
            padding: "10px",
            color: "#fff",
            borderRadius: "10px",
          }}
          variant="h4"
        >
          Data Contributors Category
        </Typography>
      </Grid>

      <Paper style={{ padding: "10px 30px" }}>
        <div className="category-container">
          {categories.map((category, index) => (
            <Tooltip title={category.title}>
              <div key={index} className="category-box">
                <img
                  style={{ marginTop: "10px", height: "55px" }}
                  src={category.image}
                  alt={category.title}
                  className="category-image"
                />
                <div className="category-label">{category.title}</div>
              </div>
            </Tooltip>
          ))}
        </div>
      </Paper>
    </Fragment>
  );
}
